/* GPX-CRO reviews — drag/touch scroll + arrows + lightbox */
(function () {
  function init(root) {
    var track = root.querySelector('[data-gpx-rvg-track]');
    var prev = root.querySelector('[data-gpx-rvg-prev]');
    var next = root.querySelector('[data-gpx-rvg-next]');
    var modal = root.closest('.gpx-rvg').querySelector('[data-gpx-rvg-modal]');
    var modalImg = modal.querySelector('.gpx-rvg__modalimg');
    if (!track) return;

    function step() {
      var s = track.querySelector('.gpx-rvg__slide');
      return s ? s.getBoundingClientRect().width + 20 : 300;
    }
    function updateBtns() {
      if (root.getAttribute('data-autoplay') === 'true') { if (prev) prev.disabled = false; if (next) next.disabled = false; return; }
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', updateBtns, { passive: true });
    window.addEventListener('resize', updateBtns);
    updateBtns();

    /* autoplay + seamless loop: the slides are cloned once, and when the scroll
       reaches the cloned half we jump back by exactly one set (no visible change) */
    var auto = root.getAttribute('data-autoplay') === 'true';
    var every = (parseInt(root.getAttribute('data-interval'), 10) || 2) * 1000;
    var paused = false, timer = null, setWidth = 0, looping = false;
    function measure() { setWidth = 0; for (var i = 0; i < n; i++) setWidth += slides[i].getBoundingClientRect().width + 20; }
    var n = track.children.length;
    if (auto && n > 1) {
      for (var c = 0; c < n; c++) { var cl = track.children[c].cloneNode(true); cl.setAttribute('aria-hidden', 'true'); cl.classList.add('is-clone'); track.appendChild(cl); }
      looping = true; measure(); window.addEventListener('resize', measure);
      track.addEventListener('scroll', function () {
        if (!looping) return;
        var half = (track.scrollWidth + 20) / 2; /* originals + clones are identical, so one set = half the scroll width */
        if (half < 50) return;
        if (track.scrollLeft >= half) track.scrollLeft -= half;
        else if (track.scrollLeft <= 0) track.scrollLeft += half;
      }, { passive: true });
      track.scrollLeft = 1;
    }
    function wrap() {
      if (!looping) return;
      var half = (track.scrollWidth + 20) / 2;
      if (half < 50) return;
      if (track.scrollLeft >= half) track.scrollLeft -= half;
      else if (track.scrollLeft <= 0) track.scrollLeft += half;
    }
    function tick() {
      if (paused || document.hidden) return;
      wrap();
      track.scrollBy({ left: step(), behavior: 'smooth' });
    }
    if (auto) {
      timer = setInterval(tick, every);
      root.addEventListener('mouseenter', function () { paused = true; });
      root.addEventListener('mouseleave', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      track.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 5000); }, { passive: true });
    }

    /* mouse drag-to-scroll (touch is native) */
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('mousedown', function (e) {
      down = true; moved = false; startX = e.pageX; startLeft = track.scrollLeft;
      track.classList.add('is-dragging'); paused = true;
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false; track.classList.remove('is-dragging'); setTimeout(function () { paused = false; }, 3000);
      setTimeout(function () { moved = false; }, 0);
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    /* lightbox */
    root.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('[data-gpx-rvg-open]');
      if (!el || moved) return;
      modalImg.src = el.getAttribute('data-image');
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
    });
    function close() { modal.classList.remove('is-active'); modal.setAttribute('aria-hidden', 'true'); modalImg.src = ''; }
    modal.querySelector('[data-gpx-rvg-close]').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  function boot() { document.querySelectorAll('[data-gpx-rvg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
